import React from "react";
import { createPortal } from "react-dom";
import moment from "moment";
import LkmSignatures from "./LkmSignatures";
import { formatNoLkm, getLkmStatus } from "../../util/lkmUtil";

const MIN_ROWS = 5;

// Dirender lewat portal langsung ke <body>.
// Di layar disembunyikan, saat print hanya elemen ini yang tampil.
const LkmPrintSheet = ({ data, dataUser }) => {
  if (!data) return null;

  const rows = [...(data.penyebab || [])];
  while (rows.length < MIN_ROWS) rows.push({ bagianRusak: "", penyebab: "" });

  return createPortal(
    <div className="lkm-print-root">
      <table className="print-head">
        <tbody>
          <tr>
            <td className="print-head-title">
              <h1>LAPORAN KERUSAKAN MOLD / MESIN</h1>
            </td>
            <td className="print-head-meta">
              <div>
                <span>Form</span>
                <b>Form-ENG-A2-R2</b>
              </div>
              <div>
                <span>No. LKM</span>
                <b>{formatNoLkm(data)}</b>
              </div>
              <div>
                <span>Status</span>
                <b>{getLkmStatus(data).label}</b>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table className="print-info">
        <tbody>
          <tr>
            <th>Tanggal</th>
            <td>{moment(data.createDate).format("DD-MM-YYYY")}</td>
            <th>Jam</th>
            <td>{moment(data.createDate).format("HH:mm")}</td>
          </tr>
          <tr>
            <th>Dari Bagian</th>
            <td>{data.dariBagian}</td>
            <th>Ke Bagian</th>
            <td>{data.keBagian}</td>
          </tr>
          <tr>
            <th>Jenis</th>
            <td>{data.jenisLkm}</td>
            <th>No. Mesin</th>
            <td>MC {data.mesin}</td>
          </tr>
          <tr>
            <th>Customer</th>
            <td>{data.customer}</td>
            <th>Mold</th>
            <td>{data.mold}</td>
          </tr>
        </tbody>
      </table>

      <p className="print-section">Kerusakan</p>
      <table className="print-damage">
        <thead>
          <tr>
            <th style={{ width: "8%" }}>No.</th>
            <th style={{ width: "46%" }}>Bagian yang Rusak</th>
            <th>Penyebab Kerusakan</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td style={{ textAlign: "center" }}>
                {r.bagianRusak || r.penyebab ? i + 1 : ""}
              </td>
              <td>{r.bagianRusak}</td>
              <td>{r.penyebab}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="print-notes">
        <div>
          <p className="print-section">Perbaikan yang Dilakukan</p>
          <div className="print-box">{data.deskripsiPerbaikan}</div>
        </div>
        <div>
          <p className="print-section">Tindakan Pencegahan</p>
          <div className="print-box">{data.deskripsiPencegahan}</div>
        </div>
      </div>

      <LkmSignatures data={data} dataUser={dataUser} printMode />

      <p className="print-foot">
        Dicetak {moment().format("DD-MM-YYYY HH:mm")}
        {dataUser && dataUser.name ? ` oleh ${dataUser.name}` : ""}
      </p>
    </div>,
    document.body
  );
};

export default LkmPrintSheet;
